import React from 'react';
import { useLocation } from 'react-router-dom';
import SimpleTabs from '../../../components/tabs/simpleTabs';
import { InternalSyncTabLinks } from '../../../components/enums/tabEnums';
import SyncTabIcon from '../../../assets/icons/sync.svg';
import DeleteTabIcon from '../../../assets/icons/delete-icon.svg';

const InternalSync = () => {
  const location = useLocation();
  const lastPathSegment = location.pathname.split('/').pop();
  const key = lastPathSegment as keyof typeof InternalSyncTabLinks;
  const activePanel = InternalSyncTabLinks[key] ?? 0;

  return (
    <div className="h-full rounded-lg border border-dark bg-white px-6 py-4">
      <SimpleTabs
        currentTab={activePanel}
        tabs={[
          {
            tabLabel: 'Sync',
            href: '/internal/sync',
            identifierName: 'sync-panel',
            icon: SyncTabIcon,
            key: 'sync',
          },
          {
            tabLabel: 'Delete',
            href: '/internal/delete',
            identifierName: 'delete-panel',
            icon: DeleteTabIcon,
            key: 'delete',
          },
        ]}
      />
    </div>
  );
};

export default InternalSync;
